import React, { useEffect, useRef } from "react";
import "./companyinfo.css";
import { FiDownload } from "react-icons/fi";
import logo from "../../assets/Compantinfo/Group 1000008451 (1) 1 (1).svg";
import { Country, State } from "country-state-city";
import { useState } from "react";
import Select from "react-select";
import axios from "axios";

function Companyinfo() {
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [stateOptions, setStateOptions] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [allPlans, setAllPlans] = useState([]);
  const [imageUrl, setImageUrl] = useState([]);
  const [formData, setFormData] = useState({
    organizationID: "",
    companyName: "",
    industryType: "",
    companyAddress: "",
    companyRegistrationNumber: "",
    founderYear: "",
    companySize: "",
    
    // companyLogo:"",
    companyWebsite: "",
    companyType: "",
    GSTIN: "",
    No_ofEmployees: "",
    userName: "",
    password: "",
    planId: "",
    city: "",
  });

  const [conPassword, setConPassword] = useState({
    confirmPassword: "",
  });
  const [error, setError] = useState("");

  console.log(formData, "formmmmmm");

  console.log(imageUrl, "sklajkljs");
  useEffect(() => {
    getPlans();
  }, []);

  const fileInputRef = useRef(null);

  const handleIconClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      console.log("Selected file:", file);
      setImageUrl([file]);
    }
  };

  const countryOptions = Country.getAllCountries().map((country) => ({
    label: country.name,
    value: country.isoCode,
    phonecode: country.phonecode,
  }));

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption);
    setCountryCode(selectedOption.phonecode);
    // Get states for the selected country
    const states = State.getStatesOfCountry(selectedOption.value).map(
      (state) => ({
        label: state.name,
        value: state.isoCode,
      })
    );
    setStateOptions(states);
    setSelectedState(null);
    setFormData((prev) => ({
      ...prev,
      country: selectedOption.label,
    }));
  };

  const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption);
    setFormData((prev) => ({
      ...prev,
      state: selectedOption.label,
    }));
  };

  const handlePhoneNumberChange = (e) => {
    const { value } = e.target;
    // Allow only numbers
    if (/^\d*$/.test(value)) {
      setPhoneNumber(value);
      setFormData((prev) => ({
        ...prev,
        phoneNumber: `${countryCode} ${value}`,
      }));
    }
  };

  const handleFields = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const getPlans = async () => {
    try {
      const response = await axios.get(
        "http://localhost:3000/api/allPremiumPlans"
      );
      setAllPlans(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmitData = async (e) => {
    e.preventDefault();

    const formPayload = new FormData();
    if (imageUrl.length > 0) {
      imageUrl?.forEach((file, index) => {
        formPayload.append(`documentsData.file${index}`, file);
        formPayload.append(`documentsData.form_type${index}`, file.type || "");
      });

      Object.keys(formData).forEach((key) => {
        formPayload.append(key, formData[key]);
      });
    }

    for (let [key, value] of formPayload.entries()) {
      console.log(`${key}:`, value);
    }

    try {
      const response = await axios.post(
        "http://localhost:3000/api/companies",
        formPayload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("Post response:", response);
      if (response.status === 201) {
        // useState({
        //   organizationID: "",
        //   companyName: "",
        //   industryType: "",
        //   companyAddress: "",
        //   companyRegistrationNumber: "",
        //   founderYear: "",
        //   // companySize:"",
        //   // companyLogo:"",
        //   companyWebsite: "",
        //   companyType: "",
        //   GSTIN: "",
        //   No_ofEmployees: "",
        //   userName: "",
        //   password: "",
        //   planId: "",
        //   city: "",
        // });
        setSelectedCountry("");
        selectedState("");
      }
    } catch (error) {
      console.error(
        "Error occurred:",
        error.response || error.message || error
      );
    }
  };

  const handlePassword = (e) => {
    const { name, value } = e.target;
    setConPassword({
      ...conPassword,
      [name]: value,
    });
    setTimeout(() => {
      if (name === "confirmPassword") {
        if (formData.password !== value) {
          setError("Password and Confirm Password do not match");
        } else {
          setError("");
        }
      }
    }, 1500);
  };

  return (
    <div className="in_outer">
      <div className="info_outer">
        <div className="info_input_items">
          <h1>COMPANY INFORMATION</h1>
          <img src={logo} alt="" className="top_log" />
          <form onSubmit={handleSubmitData}>
            <div className="info_inner">
              <div className="info_left">
                <label htmlFor="">Company name </label>
                <input
                  type="text"
                  name="companyName"
                  onChange={handleFields}
                  value={formData.companyName}
                  className="input"
                  required
                />
                <label htmlFor="">Company type </label>
                <input
                  type="text"
                  name="companyType"
                  onChange={handleFields}
                  value={formData.companyType}
                  className="input"
                  required
                />
                <label htmlFor="">Industry type</label>
                <input
                  type="text"
                  name="industryType"
                  onChange={handleFields}
                  value={formData.industryType}
                  className="input"
                  required
                />
                <label htmlFor="">Year of found</label>
                <input
                  type="text"
                  name="founderYear"
                  onChange={handleFields}
                  value={formData.founderYear}
                  className="input"
                  required
                />
                <label htmlFor=""> Registration No. (Optional) </label>
                <input
                  type="text"
                  name="companyRegistrationNumber"
                  onChange={handleFields}
                  value={formData.companyRegistrationNumber}
                  className="input"
                  required
                />
                {/* <label htmlFor="">Company size </label>
                <input type="text" name="companySize"  onChange={handleFields} value={formData.companySize} className="input" required /> */}
                <label htmlFor="">Select Plan</label>
                <select
                  name="planId"
                  onChange={handleFields}
                  value={formData.planId}
                  className="info_state_select"
                >
                  <option value="">Select </option>
                  {allPlans?.map((ele, ind) => (
                    <option
                      key={ind}
                      value={ele.id}
                    >{`${ele?.planName} - ${ele.subscription}`}</option>
                  ))}
                </select>
                <label htmlFor="">No.of Employees</label>
                <input
                  type="text"
                  name="No_ofEmployees"
                  onChange={handleFields}
                  value={formData.No_ofEmployees}
                  className="input"
                  required
                />
                <label htmlFor="">GSTIN </label>
                <input
                  type="text"
                  name="GSTIN"
                  onChange={handleFields}
                  value={formData.GSTIN}
                  className="input"
                  required
                />
                <label htmlFor="">User Name </label>
                <input
                  type="text"
                  name="userName"
                  onChange={handleFields}
                  value={formData.userName}
                  className="input"
                  required
                />
                <label htmlFor="">Password </label>
                <input
                  type="text"
                  name="password"
                  onChange={handleFields}
                  value={formData.password}
                  className="input"
                  required
                />
              </div>
              <div className="info_right">
                <label htmlFor="">Website</label>
                <input
                  type="text"
                  name="companyWebsite"
                  onChange={handleFields}
                  value={formData.companyWebsite}
                  className="input"
                  required
                />
                <label htmlFor="">Logo</label>
                <div className="download_log">
                  <input
                    type="file"
                    name=""
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    className="download_log_field"
                    required
                  />
                  <div onClick={handleIconClick}>
                    <FiDownload className="download_icon" />
                  </div>
                </div>
                <label htmlFor="">Address </label>
                <input
                  type="text"
                  name="companyAddress"
                  onChange={handleFields}
                  value={formData.companyAddress}
                  className="input"
                  required
                />
                <label htmlFor="">City </label>
                <input
                  type="text"
                  name="city"
                  onChange={handleFields}
                  value={formData.city}
                  className="input"
                  required
                />

                <label htmlFor="">Country</label>
                <Select
                  options={countryOptions}
                  value={selectedCountry}
                  onChange={handleCountryChange}
                  placeholder="Select a Country"
                />

                <label htmlFor="">State </label>
                {stateOptions.length > 0 && (
                  <>
                    <Select
                      options={stateOptions}
                      value={selectedState}
                      onChange={handleStateChange}
                      placeholder="Select a State"
                    />
                  </>
                )}

                <label>Phone Number:</label>

                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <input
                    type="text"
                    value={`+${countryCode}`}
                    readOnly
                    style={{ width: "60px", textAlign: "center" }}
                    placeholder="Code"
                  />

                  <input
                    type="text"
                    value={phoneNumber}
                    onChange={handlePhoneNumberChange}
                    placeholder="Phone Number"
                    style={{ flex: 1 }}
                  />
                </div>
                <label htmlFor="">Organization Id </label>
                <input
                  type="text"
                  name="organizationID"
                  onChange={handleFields}
                  value={formData.organizationID}
                  className="input"
                  required
                />
                <label htmlFor="">confirm Password </label>
                <p>{error && error}</p>
                <input
                  type="text"
                  name="confirmPassword"
                  onChange={handlePassword}
                  value={conPassword.confirmPassword}
                  className="input"
                  required
                />
              </div>
            </div>
            <div className="info_button">
              <button type="submit">Explore Services</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Companyinfo;
